if (!customElements.get('product-add-to-cart-sticky')) {
class ProductAddToCartSticky extends HTMLElement {
    constructor() {
        super();
        this.handleScroll = this.handleScroll.bind(this);
        this.scheduleScroll = this.scheduleScroll.bind(this);
        this.scrollFrame = null;
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.sectionId = this.dataset.section;
    }

    connectedCallback() {
        this.targetElement = document.querySelector('[id^="ProductSubmitButton-"]');
        // Use the site footer; a bare 'footer' selector can match hidden in-page footers (e.g. the compare dialog) at offset 0.
        this.footerElement = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer.footer') || document.querySelector('footer');
        this.stickyAtcVariantInput = this.querySelector('.product-variant-id');

        window.addEventListener("scroll", this.scheduleScroll, { passive: true });
        window.addEventListener("resize", this.scheduleScroll, { passive: true });
        this.scheduleScroll();
        document.body.addEventListener('change', this.handleVariantChange);
    }

    disconnectedCallback() {
        window.removeEventListener("scroll", this.scheduleScroll);
        window.removeEventListener("resize", this.scheduleScroll);
        if (this.scrollFrame !== null) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        document.body.removeEventListener('change', this.handleVariantChange);
    }

    scheduleScroll() {
        if (this.scrollFrame !== null) return;
        this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            if (this.isConnected) this.handleScroll();
        });
    }

    getAbsoluteTop(element) {
        let top = 0;
        while (element) {
            top += element.offsetTop || 0;
            element = element.offsetParent;
        }
        return top;
    }

    handleScroll() {
        if (!this.targetElement) return;
        const targetTopPosition = this.getAbsoluteTop(this.targetElement);
        const footerTopPosition = this.footerElement ? this.getAbsoluteTop(this.footerElement) : 0;
        const isFooterInView = footerTopPosition > 0 && window.scrollY + window.innerHeight > footerTopPosition;
        /* 20/10/2026 OCCHIO (audit mobile): su mobile il tasto principale sta a due schermate e mezza dal top.
           La barra sticky (prezzo + Aggiungi) si mostra quando il tasto principale NON è nel viewport, sopra o sotto,
           quindi anche nella prima schermata. Su desktop resta il comportamento originale (solo dopo averlo superato). */
        let isTargetElementOutOfView;
        if (window.innerWidth < 768) {
            const rect = this.targetElement.getBoundingClientRect();
            const bottomSafe = window.innerHeight - this.offsetHeight;
            isTargetElementOutOfView = rect.bottom < 0 || rect.top > bottomSafe;
        } else {
            isTargetElementOutOfView = targetTopPosition < window.scrollY;
        }

        if (isTargetElementOutOfView && !isFooterInView) {
            this.classList.add('show');
        } else {
            this.classList.remove('show');
        }
    }

    updateStickyATCOption(optionName, optionValue) {
        const matches = optionName.match(/options\[(.+)\]/);
        if (matches && matches[1]) {
            optionName = matches[1];
        }

        const optionDisplay = this.querySelector('.selected-variant-option[data-option-name="' + optionName + '"]');
        if (optionDisplay) {
            optionDisplay.textContent = optionName + ': ' + optionValue;
        }
    }

    handleVariantChange(event) {
        const target = event.target;
        const productSection = target.closest(`#MainProduct-${this.sectionId}`);
        if (!productSection) return;
        if (target.tagName === 'INPUT' || target.tagName === 'SELECT') {
            const optionName = target.name;
            const optionValue = target.tagName === 'INPUT' ? target.value : target.options[target.selectedIndex].textContent;
            this.updateStickyATCOption(optionName, optionValue);
        }
    }
}

customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}
